import React from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { Menu } from 'antd';
import colors from '../../scss/variables.module.scss';

/* internal transfer sub menu data */
const internalTransferSubMenu = [
  { name: 'Weighbridge (Product)', path: '/shipment/internalTransfer/weighbridge/product/create' },
  { name: 'Weighbridge (Paddy)', path: '/shipment/internalTransfer/weighbridge/paddy/create' },
  { name: 'Manual', path: '/shipment/internalTransfer/manual' },
];

/* React functional component */
const InternalTransferTabLayout = () => {
  /* extracting location from useLocation hook */
  const location = useLocation();

  return (
    <div className="subMenu">
      <Menu
        style={{ backgroundColor: colors.colorBlack, display: 'flex' }}
        selectedKeys={[location.pathname]}
      >
        {internalTransferSubMenu.map((item) => {
          return (
            <Menu.Item key={item.path}>
              <Link to={item.path} style={{ fontWeight: '500', fontSize: 14 }}>
                {item.name}
              </Link>
            </Menu.Item>
          );
        })}
      </Menu>
      <Outlet />
    </div>
  );
};

export default InternalTransferTabLayout;
